import React, { createContext, useContext, useEffect, useState } from "react";
import { saveOrder } from "../Utils/Utils";
import { useAuth } from "./AuthContext";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const raw = localStorage.getItem("af_cart");
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser } = useAuth() || {};

  useEffect(() => {
    localStorage.setItem("af_cart", JSON.stringify(cart));
  }, [cart]);

  const addItem = (product, quantity = 1) => {
    const imageUrl =
      (product && product.imagesUrls && product.imagesUrls[0]) ||
      product.imageUrl ||
      product.image ||
      "";
    setCart((prev) => {
      const exists = prev.find((p) => p.productId === product.id);
      if (exists) {
        return prev.map((p) =>
          p.productId === product.id
            ? {
                ...p,
                quantity: p.quantity + quantity,
                imageUrl: p.imageUrl || imageUrl,
                imagesUrls:
                  p.imagesUrls && p.imagesUrls.length > 0
                    ? p.imagesUrls
                    : imageUrl
                    ? [imageUrl]
                    : [],
              }
            : p
        );
      }
      return [
        ...prev,
        {
          productId: product.id,
          productName: product.productName,
          price: Number(product.price) || 0,
          quantity,
          imageUrl,
          imagesUrls: product.imagesUrls || (imageUrl ? [imageUrl] : []),
        },
      ];
    });
    setIsOpen(true);
  };

  const removeItem = (productId) => {
    setCart((prev) => prev.filter((p) => p.productId !== productId));
  };

  const updateQuantity = (productId, qty) => {
    setCart((prev) =>
      prev.map((p) => (p.productId === productId ? { ...p, quantity: qty } : p))
    );
  };

  const clearCart = () => setCart([]);

  const getTotal = () => cart.reduce((s, i) => s + i.price * i.quantity, 0);

  const checkout = async (clientInfo) => {
    if (!cart || cart.length === 0) throw new Error("Cart is empty");
    const order = {
      orderStatus: true,
      paymentStatus: true,
      products: cart.map((i) => ({
        productId: i.productId,
        productName: i.productName,
        quantity: i.quantity,
      })),
      clientName: clientInfo.name || (currentUser && currentUser.name) || "Client",
      clientPhone: clientInfo.phone || "",
      total: getTotal(),
      date: new Date().toISOString().split("T")[0],
      wilaya: clientInfo.wilaya || "",
      address: clientInfo.address || "",
      email: clientInfo.email || (currentUser && currentUser.email) || "",
      appSource: "active Fitness Web App",
    };

    const res = await saveOrder(order);
    clearCart();
    return res;
  };

  return (
    <CartContext.Provider
      value={{ cart, addItem, removeItem, updateQuantity, clearCart, getTotal, checkout, isOpen, setIsOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);

export default CartContext;
